<div class="toast-container">
    <div *ngFor="let toast of toasts" [@toastAnimation] [ngClass]="{
      'toast-success': toast.type === 'success',
      'toast-error': toast.type === 'error',
      'toast-warning': toast.type === 'warning',
      'toast-info': toast.type === 'info'
    }" class="toast">

        <!-- Icon -->
        <div class="toast-icon" [innerHTML]="getIcon(toast.type)"></div>

        <!-- Message -->
        <div class="toast-message">
            {{ toast.message }}
        </div>

        <!-- Close button -->
        <button (click)="removeToast(toast.id)" class="toast-close" aria-label="Fermer">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd" />
            </svg>
        </button>
    </div>
</div>